import { createConsumer } from '@rails/actioncable'
import i18n from '@/i18n'

const sensorMmChannelSubscribedEmsIds = []
const sensorMmChannelSubscribedSensorSids = []

export function subscribe({ params, callback, commit, consumer }) {
  const t = i18n.global.t
  consumer ||= createConsumer()
  consumer.subscriptions.create(params, {
    connected: () => {
      commit('notifications/DELETE_TOAST', 'connection', {
        root: true
      })
    },
    disconnected: () => {
      commit(
        'notifications/PUSH_TOAST',
        {
          autohide: false,
          content: t('api.general.disconnected_body'),
          id: 'connection',
          title: t('api.general.disconnected'),
          type: 'warning',
          showAfterMs: 20000
        },
        {
          root: true
        }
      )
    },
    received: (data) => {
      callback(data)
    }
  })
}

export function subscribeToCustomerEmsSensorMmChannels({ emsIds, store }) {
  const hasPermissionRestriction = store.state.measurements.permission.sensors.hasPermissionRestriction
  const consumer = createConsumer()

  if (hasPermissionRestriction) {
    const sensorSids = store.getters['measurements/sensorSids']
    for (const sid of sensorSids) {
      if (sensorMmChannelSubscribedSensorSids.includes(sid)) {
        continue
      }

      sensorMmChannelSubscribedSensorSids.push(sid)
      subscribe({
        params: {
          channel: 'CustomerEmsSensorMmChannel',
          type: 'sensor',
          sid: sid
        },
        callback: (data) => {
          store.commit('measurements/SET_INSTANT_UPDATE_VALS', data)
        },
        commit: store.commit,
        consumer
      })
    }
  } else {
    for (const emsId of emsIds) {
      if (sensorMmChannelSubscribedEmsIds.includes(emsId)) {
        continue
      }

      sensorMmChannelSubscribedEmsIds.push(emsId)
      subscribe({
        params: {
          channel: 'CustomerEmsSensorMmChannel',
          type: 'ems_sensor',
          ems_id: emsId
        },
        callback: (data) => {
          store.commit('measurements/SET_INSTANT_UPDATE_VALS', data)
        },
        commit: store.commit,
        consumer
      })

      const statusSensorIds = store.getters['measurements/dashboardStatusSensorIds']
      for (const id of statusSensorIds) {
        sensorMmChannelSubscribedSensorSids.push(id)

        subscribe({
          params: {
            channel: 'CustomerEmsSensorMmChannel',
            type: 'status_sensor',
            id
          },
          callback: (data) => {
            store.commit('measurements/SET_INSTANT_UPDATE_STATUS_VAL', data)
          },
          commit: store.commit,
          consumer
        })
      }
    }
  }
}
